import React from "react"
import { StaticImage } from "gatsby-plugin-image"

// import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql, navigate } from "gatsby"
import { useForm, ValidationError } from "@formspree/react"

const IndexPage = ({ data }) => {
  const page = data.page.nodes
  const content = page[0]?.content
  const [state, handleSubmit] = useForm("xyyalewn")

  if (state.succeeded) {
    navigate("/thank-you")
  }

  return (
    <div>
      <Seo title="Contact Us" yoast={page[0]?.seo.fullHead} schema={page[0]?.seo.schema.raw} />

      <section className="py-5 container">
        <div className="row">
          <div className="col-12 col-md-8 offset-md-2">
            <h3 className="color_red_dark mb-5 text-center">
              Please fill up the form for advertising or general enquiries.
              <br />
              <br />
              Please do not use this form to book any dining reservations.
            </h3>
          </div>
        </div>
        <div class="row mb-10">
          <div class="col-12 col-lg-8 offset-lg-2">
            <form method="post" onSubmit={handleSubmit} className="row">
              <div class="col-12 col-lg-4">
                <div class="form-floating mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="txt_name"
                    name="name"
                    placeholder="Name"
                    required
                  />
                  <label for="txt_name">Name</label>
                  <ValidationError
                    prefix="Name"
                    field="name"
                    errors={state.errors}
                  />
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-floating mb-3">
                  <input
                    type="text"
                    class="form-control"
                    id="txt_phone"
                    name="phone"
                    placeholder="Phone"
                    required
                  />
                  <label for="txt_phone">Phone</label>
                  <ValidationError
                    prefix="Phone"
                    field="phone"
                    errors={state.errors}
                  />
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-floating mb-3">
                  <input
                    type="email"
                    class="form-control"
                    id="txt_email"
                    name="email"
                    placeholder="Email"
                    required
                  />
                  <label for="txt_email">Email</label>
                  <ValidationError
                    prefix="Email"
                    field="email"
                    errors={state.errors}
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-floating mb-3">
                  <textarea
                    class="form-control"
                    placeholder="Message"
                    id="txt_message"
                    name="message"
                    required
                  ></textarea>
                  <label for="txt_message">Message</label>
                  <ValidationError
                    prefix="Message"
                    field="message"
                    errors={state.errors}
                  />
                </div>
              </div>
              <div class="col-12 text-center">
                <button type="submit" class="btn btn-lg btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="row d-flex align-items-center mb-8">
          <div className="col-12 col-lg-5 col-xl-4">
            <h1 className="title text-uppercase my-5">Contact Us</h1>
            <h3 className="color_red_dark text-uppercase mb-2">
              Contact Details
            </h3>
            <p>
              Email:&nbsp;
              <a href="mailto:maureen@misstamchiak.com">
                maureen@misstamchiak.com
              </a>
            </p>
            <h3 className="color_red_dark text-uppercase mb-2">
              Follow us on social network
            </h3>
            <p>
              <a
                href="https://www.facebook.com/misstamchiak"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
              <br />
              <a
                href="https://www.instagram.com/misstamchiak"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
              <br />
              <a
                href="https://www.youtube.com/channel/UC5qiiQs_Iajx7EmAznHI82A"
                target="_blank"
                rel="noreferrer"
              >
                Youtube
              </a>
            </p>
            <h3 className="color_red_dark text-uppercase mb-2">Address</h3>
            <p>
              18 Sin Ming Lane,
              <br />
              #02-07 Midview City,
              <br />
              Singapore 573960
            </p>
          </div>
          <div className="col-12 col-lg-7 col-xl-8">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.696127756684!2d103.8316613759243!3d1.3589545986281917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1700686e7fa3%3A0xa4a1f4139bf92b15!2sMidview%20City!5e0!3m2!1sen!2ssg!4v1721545511041!5m2!1sen!2ssg"
              width="100%"
              height="600"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query PageContent {
    page: allWpPage(filter: { title: { eq: "Thank You" } }) {
      nodes {
        title
        content
        seo {
          fullHead
          schema {
            raw
          }
        }
      }
    }
  }
`
